'use client'

import React, {useContext, useState} from 'react'
import {createFormControl, DefaultValues} from 'react-hook-form'
import {Mode} from 'react-hook-form'
import {ZodTypeAny} from 'zod'

const FormControlContext = React.createContext<Nullable<ReturnType<typeof createFormControl>>>(null)

export const FormControlProvider = ({children}: React.PropsWithChildren) => {
  const [formControl] = useState(createFormControl)

  return <FormControlContext.Provider value={formControl}>{children}</FormControlContext.Provider>
}

export const useFormControl = () => {
  const control = useContext(FormControlContext)

  if (!control) throw Error('No FormControlProvider')

  return control
}

export interface FormControlProps extends React.PropsWithChildren {
  data?: DefaultValues<any>
  schema?: ZodTypeAny
  resolver?: (...props: any[]) => any
  mode?: Mode
}

export const withFormControl = (WrappedComponent: React.FC<any>) => {
  return function Wrapper(props: React.PropsWithChildren<FormControlProps>) {
    return (
      <FormControlProvider>
        <WrappedComponent {...props}>{props.children}</WrappedComponent>
      </FormControlProvider>
    )
  }
}
